import type { GatewaysList } from './gateways.enum'

export class GatewayPublicInfo {
    brands: Brands[]
    label: string
    requiredCustomerInfo: string[]
    gatewayPaymentMethods: string[]
    gatewayPurchaseTypes: Record<string, string[]>
    // só aparecem os meios com alguma capacidade de estorno
    gatewayRefundCapabilities?: Record<string, RefundCapability>
}

export class Gateway {
    gatewayId: string
    companyId: string
    label: string
    appId?: string
    secret?: string
    token?: string
    tokenExpiration?: Date
    createdAt: Date
    updatedAt: Date
    gateway: GatewaysList
    logs?: any[]
    status: number
    purchase?: any[]
    brands: Brands[]
    issuerAddress: string
    issuerPhone: string
    issuerEmail: string
    issuerLegalName: string
    issuerBusinessName: string
    issuerDocument: string
    billIntegration: string[]
    // meios de pagamento que este gateway aceita ('credit', 'bankslip', ...). vem calculado pela
    // api a partir do adapter do gateway — é a fonte de verdade, não deduza pelo nome do gateway.
    gatewayPaymentMethods?: string[]
    // tipos de cobrança aceitos POR MEIO de pagamento: { credit: ['full_charge'], pix: [...] }.
    // a restrição costuma ser da combinação, não do gateway inteiro — no Mercado Pago o pix faz
    // recorrência e o cartão só faz à vista.
    gatewayPurchaseTypes?: Record<string, string[]>
    gatewayRefundCapabilities?: Record<string, RefundCapability>
    requiredCustomerInfo?: string[]
}

export class Brands {
    brand: GatewaysBrands
    installments: number
}

export enum GatewaysBrands {
    'visa' = 'visa',
    'master' = 'master',
    'elo' = 'elo',
    'amex' = 'amex',
    'aura' = 'aura',
    'jcb' = 'jcb',
    'diners' = 'diners',
    'discover' = 'discover',
    'hipercard' = 'hipercard',
    'hiper' = 'hiper',
}

// O que o gateway sabe desfazer num meio de pagamento. Vem do adapter, não de lista mantida à
// parte: quem for oferecer estorno na tela pergunta aqui.
export class RefundCapability {
    // desfazer o que ainda não foi pago: invalidar o QR do pix, desfazer a autorização do cartão
    cancelUnpaid: boolean
    // devolver dinheiro de uma cobrança paga
    refundPaid: boolean
    // estornar menos que o valor total
    partial: boolean
}
